<template>
  <div>
    <!-- 搜索表单区域 -->
    <el-form :model="query" label-width="125px" inline size="mini">
      <el-form-item label="退款订单号">
        <el-input v-model="query.orderUuid" clearable placeholder="请输入退款订单号"></el-input>
      </el-form-item>
      <el-form-item label="支付订单号">
        <el-input v-model="query.payOrderUuid" clearable placeholder="请输入支付订单号"></el-input>
      </el-form-item>
      <!-- <el-form-item label="用户手机号">
        <el-input v-model="query.userCellphone" clearable placeholder="请输入用户手机号码"></el-input>
      </el-form-item> -->
      <el-form-item label="订单状态">
        <el-select v-model="query.status" clearable placeholder="请选择订单状态">
          <el-option label="退款中" value="0"></el-option>
          <el-option label="退款完成" value="1"></el-option>
          <el-option label="退款失败" value="2"></el-option>
          <el-option label="取消退款" value="3"></el-option>
        </el-select>
      </el-form-item>
      <!-- 创建时间段 -->
      <el-form-item label="创建时间段">
        <el-date-picker
          v-model="ctPeriod"
          value-format="yyyy-MM-dd"
          unlink-panels
          type="daterange"
          range-separator="至"
          start-placeholder="创建起始时间"
          end-placeholder="创建结束时间"
        ></el-date-picker>
      </el-form-item>
      <!-- 退款时间段 -->
     <!-- <el-form-item label="退款时间段">
        <el-date-picker
          v-model="rtPeriod"
          value-format="yyyy-MM-dd"
          unlink-panels
          type="daterange"
          range-separator="至"
          start-placeholder="退款起始时间"
          end-placeholder="退款结束时间"
        ></el-date-picker>
      </el-form-item> -->
      <!-- <el-button class="custodyBtn" type="warning" size="mini" @click="custody">重置</el-button> -->
      <el-button type="primary" size="mini" @click="seach">搜索</el-button>
    </el-form>
    <!-- 卡片视图区域 -->
    <el-card>
      <!-- 表格数据展示区域 -->
      <el-table :data="refundList" style="width: 100%" height="650px" border stripe>
        <el-table-column type="expand">
          <template slot-scope="scope">
            <el-form label-width="110px" label-position="left" inline class="expand">
              <el-form-item label="用户ID">
                <span>{{ scope.row.userUuid }}</span>
              </el-form-item>
              <el-form-item label="支付订单号">
                <span>{{ scope.row.payOrderUuid }}</span>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column prop="uuid" label="退款订单号" width="240"></el-table-column>
        <el-table-column prop="amount" label="退款/元" align="right"></el-table-column>
        <el-table-column prop="amount1" label="退回积分" align="right"></el-table-column>
        <el-table-column prop="detail" label="退款描述"></el-table-column>
        <el-table-column prop="status" label="退款状态">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status === 0" type="warning">退款中</el-tag>
            <el-tag v-else-if="scope.row.status === 1" type="success">退款完成</el-tag>
            <el-tag v-else-if="scope.row.status === 2" type="danger">退款失败</el-tag>
            <el-tag v-else type="info">取消退款</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间"></el-table-column>
        <!-- <el-table-column prop="refundTime" label="退款时间"></el-table-column> -->
        <el-table-column prop="finishTime" label="完成时间"></el-table-column>
        <el-table-column prop="transactionId" label="退款流水" width="260"></el-table-column>
      </el-table>
      <!-- 分页区域 -->
      <el-pagination
        @size-change="pageSizeChange"
        @current-change="CurrentPageChange"
        :current-page="query.curPage"
        :page-sizes="[5, 10, 15]"
        :page-size="query.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </el-card>
  </div>
</template>

<script>
import { refund } from '@/API/order'
export default {
  name: 'refund',
  data() {
    return {
      query: {
        curPage: 1,
        pageSize: 10,
        orderUuid: '',
        payOrderUuid: '',
        userCellphone: '',
        ctStart: '',
        ctEnd: '',
        rtStart: '',
        rtEnd: ''
      },
      ctPeriod: [],
      rtPeriod: [],
      // 退款订单列表
      refundList: [],
      //   数据总条数
      total: 0
    }
  },
  created() {
    let startDate = new Date()
    startDate.setTime(startDate.getTime() - 30 * 24 * 3600 * 1000)
    this.ctPeriod[0] = startDate.getFullYear() + (startDate.getMonth() + 1 < 10 ? '-0' : '-') + (startDate.getMonth() + 1) + (startDate.getDate() < 10 ? '-0' : '-') + startDate.getDate()
    this.query.ctStart = this.ctPeriod[0]
    let endDate = new Date()
    this.ctPeriod[1] = endDate.getFullYear() + (endDate.getMonth() + 1 < 10 ? '-0' : '-') + (endDate.getMonth() + 1) + (startDate.getDate() < 10 ? '-0' : '-') + startDate.getDate()

    this.query.ctEnd = this.ctPeriod[1]
    this.getRefundList()
  },
  methods: {
    async getRefundList() {
      const { data: res } = await refund(this.query)
      if (res.code !== 200) return this.$message.error(res.message)
      // this.$message.success(res.message)
      this.refundList = res.data.entities
      this.total = res.data.totalSize
    },
    // 重置按钮点击事件
    custody() {
      this.query = {
        curPage: 1,
        pageSize: 10
      }
      this.ctPeriod = []
      this.rtPeriod = []
      this.getRefundList()
    },
    // 搜索按钮点击事件
    seach() {
      this.query.curPage = 1
      if (this.stPeriod != null) {
        this.query.ctStart = this.ctPeriod[0]
        this.query.ctEnd = this.ctPeriod[1]
      } else {
        this.query.ctStart = ''
        this.query.ctEnd = ''
      }
      if (this.rtPeriod != null) {
        this.query.rtStart = this.rtPeriod[0]
        this.query.rtEnd = this.rtPeriod[1]
      } else {
        this.query.rtStart = ''
        this.query.rtEnd = ''
      }
      this.getRefundList()
    },
    // 监听pageSize
    pageSizeChange(newSize) {
      this.query.pageSize = newSize
      this.getRefundList()
    },
    // 监听curPage
    CurrentPageChange(newPage) {
      this.query.curPage = newPage
      this.getRefundList()
    }
  }
}
</script>

<style lang="less" scoped>
.expand {
  .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 33%;
  }
}
.custodyBtn {
  margin-left: 70px;
}
.el-pagination {
  margin-top: 30px;
}
</style>
